import {Dropdown} from '@/components/atoms'
import {usePromotion} from '@/context/Promotion/PromotionContext'
import {GiftItemReward} from '@/types/promotion'
import {buyOptions, giftItemOptions} from '@/utils/constants/promotionConstants'
import {DropdownItem} from 'pepsico-ds'
import {FC} from 'react'
import {RewardItemProps} from './RewardItem'
import {useRewardValidations} from './RewardValidations.js'

export const RewardGiftItem: FC<RewardItemProps> = ({promotionCondition}) => {
  const {updateCondition} = usePromotion()
  const {hasValueLayerError} = useRewardValidations(promotionCondition)
  const reward = promotionCondition.rewards?.[0] as GiftItemReward

  const updateReward = (update: Partial<GiftItemReward>) => {
    const currentReward = promotionCondition?.rewards?.[0] ?? {}

    const mergedReward = {
      ...currentReward,
      ...update,
    } as GiftItemReward

    updateCondition({
      sequence: promotionCondition.sequence,
      rewards: [mergedReward],
    })
  }

  const quantityValue = buyOptions.filter(item => item.id === reward?.quantity?.toString())
  const gittItemValue = giftItemOptions.filter(item => reward.items?.find(id => id === item.id))

  const isError = hasValueLayerError()

  return (
    <>
      <Dropdown
        isJsonWrap={false}
        childList={buyOptions}
        placeholder="Any"
        updateValue={(values: DropdownItem[]) => {updateReward({quantity: Number(values[0]?.id)})}}
        value={quantityValue}
        isClearable={false}
        // @ts-expect-error type
        style={{maxWidth: '120px'}}
        autocomplete="off"
        isError={isError}
        errorMessage="Value Invalid"
      />
      <Dropdown
        isJsonWrap={false}
        childList={giftItemOptions}
        placeholder="Any"
        updateValue={(values: DropdownItem[]) => updateReward({items: [values[0]?.id]})}
        isClearable={false}
        value={gittItemValue}
        autocomplete="off"
      />
    </>
  )
}
